import { render, staticRenderFns } from "./AdStatus.vue?vue&type=template&id=f00e6068&scoped=true&"
import script from "./AdStatus.vue?vue&type=script&lang=ts&"
export * from "./AdStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00e6068",
  null
  
)

export default component.exports